
import { Layout } from '@roc/feature-app-core';
import { observer } from 'mobx-react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { MyCadenceSection } from './myCadencesSection';


const useStyles = makeStyles((theme: Theme) => ({
}));


export const CadenceDashboardHome = observer(() => {
  const classes = useStyles();

  return (
    <Layout title="My Cadences">
        <MyCadenceSection></MyCadenceSection>
    </Layout>
  );
});
